import { useReactiveVar } from '@apollo/client';
import { useField } from 'formik';
import { FC, useContext } from 'react';

import useGetAdAccountIdsByCampaigns from '../../../../../../apis/graphql/accountManagement/adAccount/useGetAdAccountIdsByCampaigns/useGetAdAccountIdsByCampaigns';
import useGetReportSecondaryUsersList from '../../../../../../apis/graphql/reports/useGetReportSecondaryUsersList';
import MultiSelect from '../../../../../../components/BlueTheme/MultiSelect/MultiSelect';
import { Option } from '../../../../../../components/types';
import { selectedOrganizationIdVar } from '../../../../../../constants';
import { GlobalPermissionsContext } from '../../../../../../context';
import { StyledLabel, StyledMultiSelectWrapper } from '../../../../Reports/ReportFilterModal/CampaignsDropDown/styled';
import { RECIPIENTS } from '../constants';
import { ReportFormValues } from '../types';

interface Props {
  campaignIds: string[];
}

export const SecondaryUsers: FC<Props> = ({ campaignIds }): JSX.Element => {
  const organizationId = useReactiveVar(selectedOrganizationIdVar);
  const [_, { touched, error, value }, { setValue }] = useField<ReportFormValues['recipients']>(RECIPIENTS);
  const { data: adAccountIds, loading: adAccountsListLoading } = useGetAdAccountIdsByCampaigns(campaignIds);
  const { roles } = useContext(GlobalPermissionsContext);
  const excludeSellers = !roles?.includes('SELLER');
  const { loading, users } = useGetReportSecondaryUsersList(
    organizationId || '',
    adAccountIds,
    excludeSellers,
    adAccountsListLoading
  );

  const options = users.map(({ id, firstName, lastName }) => {
    return { value: id, label: `${firstName} ${lastName || ''}` };
  });

  const onSelectionChanged = (selectedUsers: Option[]): void => {
    setValue(selectedUsers.map((selectedUser) => selectedUser.value));
  };

  return (
    <StyledMultiSelectWrapper>
      <StyledLabel>Select User(s)</StyledLabel>
      <MultiSelect
        testId="recipientsMultiselectInput"
        loading={loading || adAccountsListLoading}
        allItems={options}
        maxSelectedItemsCount={10000}
        onChange={onSelectionChanged}
        errorMessage={(touched && error) || ''}
        total={options.length}
        initiallySelected={value}
      />
    </StyledMultiSelectWrapper>
  );
};
